export const corporationSearchFormBaseUrl = "/api/v1/corporations";
